class ShareButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.share-button__button');
    this.fallback = this.querySelector('.share-button__fallback');
    this.closeButton = this.querySelector('.share-button__close');
    this.copyButton = this.querySelector('.share-button__copy');
    this.successMessage = this.querySelector('.share-button__message');
    this.urlInput = this.querySelector('input');
    
    this.button.addEventListener('click', () => this.toggle());
    this.closeButton.addEventListener('click', () => this.close());
    this.copyButton.addEventListener('click', () => this.copyToClipboard());
  }

  toggle() {
    this.fallback.classList.toggle('active');
  }

  close() {
    this.fallback.classList.remove('active');
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.urlInput.value).then(() => {
      this.successMessage.classList.remove('hidden');
      this.successMessage.textContent = 'Link copied';
      setTimeout(() => {
        this.successMessage.classList.add('hidden');
      }, 2000);
    });
  }

  // Method expected by Dawn theme's product-info.js
  updateUrl(url) {
    if (this.urlInput) {
      this.urlInput.value = url;
    }

    // Update social media links
    const facebookLink = this.querySelector('a[href*="facebook.com"]');
    const twitterLink = this.querySelector('a[href*="twitter.com"]');
    const pinterestLink = this.querySelector('a[href*="pinterest.com"]');

    if (facebookLink) {
      facebookLink.href = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
    }

    if (twitterLink) {
      const productTitle = document.querySelector('.product-title-main')?.textContent || document.title;
      twitterLink.href = `https://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(productTitle)}`;
    }

    if (pinterestLink) {
      const productTitle = document.querySelector('.product-title-main')?.textContent || document.title;
      const featuredImage = document.querySelector('.main-product__slide img')?.src || '';
      pinterestLink.href = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(featuredImage)}&description=${encodeURIComponent(productTitle)}`;
    }
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton);
}
